import { createContext, useContext } from 'react';

/**
 * Set by `AsaFlowShell` around ASA's voucher / membership purchase. The shared checkout form's
 * guest path prices the action from the booking cart, which is empty on these pages, so it would
 * read "Book now" and show the booking cancellation note. The village terms card reads this
 * instead: the voucher's own price, and no booking note. Absent everywhere else.
 */
export interface AsaPurchase {
  price: number;
}

export const AsaPurchaseContext = createContext<AsaPurchase | undefined>(undefined);

export const useAsaPurchase = () => useContext(AsaPurchaseContext);
